import { SphereGeometry, MeshNormalMaterial } from 'three';
import InstancedShapes, { scatter } from './InstancedShapes.js';
import gsap from 'gsap';

export default class Spheres extends InstancedShapes {
    constructor(amount, repulsion) {
        super(
            new SphereGeometry(0.2, 20, 20),
            new MeshNormalMaterial(),
            amount,
            repulsion
        );
        this.place(scatter(10, 1.75));

        gsap.from(this.positions, {
            x: Math.cos(this.isMobile ? 5.2 : 11),
            y: Math.sin(this.isMobile ? 5.2 : 11),
            z: Math.sin(this.isMobile ? 5.2 : 11),
            duration: 12.5,
            yoyo: true,
            repeat: -1,
            stagger: 0.01,
            ease: "back.inOut(1.7)",
            repeatDelay: 8,
        });
    }
}
